import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { H2Atom, PAtom } from '@atoms/text-atoms/text-atoms';
import { KeyMetricsProps } from './key-metrics-framework.types';

const KeyMetrics: React.FC<KeyMetricsProps> = ({
  title,
  children,
  footnote,
  className,
  isVisible = true,
}) => {
  if (isVisible) {
    return (
      <div className={className} data-testid="key-metrics-framework">
        {title && <H2Atom>{title}</H2Atom>}
        <div className="key-metrics-table-container">{children}</div>
        {footnote && <PAtom className="footnote">* {footnote}</PAtom>}
      </div>
    );
  } else {
    return null;
  }
};

const StyledKeyMetrics = styled(KeyMetrics)`
  width: 100%;
  padding: 3rem 0;

  ${H2Atom} {
    padding-bottom: 1rem;
    ${vars.fontSize8}
    color: ${vars.coreDarkGrey};
  }
  ${PAtom} {
    ${vars.fontSize4}
  }
  .key-metrics-table-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export default StyledKeyMetrics;
